var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseAccountFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2710_4932)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 12a6 6 0 110 12 6 6 0 010-12zm2.53 3.47a.75.75 0 00-1.004-.052l-.056.052L18 16.94l-1.47-1.47-.056-.052a.75.75 0 00-1.056 1.056l.052.056L16.94 18l-1.47 1.47-.052.056a.75.75 0 001.056 1.056l.056-.052L18 19.06l1.47 1.47.056.052a.75.75 0 001.056-1.056l-.052-.056L19.06 18l1.47-1.47.052-.056a.75.75 0 00-.052-1.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.212 13.129A7.469 7.469 0 0010.413 18c0 1.067.224 2.081.625 3H3.912c-.552 0-.99-.448-.9-.993C3.36 17.89 4.93 13.125 12 13.125c.071 0 .142.003.212.004zM12 3c2.51 0 4.544 2.015 4.544 4.5S14.51 12 12 12 7.456 9.985 7.456 7.5 9.49 3 12 3z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2710_4932"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
}
SvgCloseAccountFilled.displayName = 'CloseAccountFilled';
export default SvgCloseAccountFilled;